module.exports = __webpack_public_path__ + "img/image_placehoder.a5ebc045.png";